/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".colorSquareStyle[_ngcontent-%COMP%]{flex-grow:1;align-items:center;justify-content:center}.colorSquareStyle[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{text-align:center;font-size:medium}"];
export { styles as styles };
